import type React from 'react';
import { useState } from 'react';
import { ProgressStepContext } from '@/contexts/progressStepContext';

export const ProgressStepProvider = ({
	children
}: {
	children: React.ReactNode;
}): React.JSX.Element => {
	const [stepOverride, setStepOverride] = useState<number | null>(null);

	return (
		<ProgressStepContext.Provider value={{ stepOverride, setStepOverride }}>
			{children}
		</ProgressStepContext.Provider>
	);
};
